import { useQuery } from 'react-query';

import { QueryConfig } from '@/utils/react-query';

import * as v1 from './aniftyTokenV1GraphClient';
import * as v2 from './aniftyTokenV2GraphClient';

export type TokenVersion = 1 | 2;

/**
 * Returns an array of token versions for specific token id
 * This calls both v1 and v2 subgraph to see if specified token exists on each contracts
 *
 * @param {string | number} tokenID
 */
export const getTokenVersions = async ({
  tokenID,
}: {
  tokenID: string | number;
}): Promise<TokenVersion[]> => {
  const [v1TokenData, v2TokenData] = await Promise.all([
    v1.getTokenInfoByID(tokenID),
    v2.getTokenInfoByID(tokenID),
  ]);

  const tokenVersions: TokenVersion[] = [];

  if (
    v1TokenData.aniftyTokens.length &&
    parseInt(v1TokenData.aniftyTokens[0].totalTokenAmount) > 0
  ) {
    tokenVersions.push(1);
  }

  if (
    v2TokenData.aniftyTokens.length &&
    parseInt(v2TokenData.aniftyTokens[0].totalTokenAmount) > 0
  ) {
    tokenVersions.push(2);
  }

  return tokenVersions;
};

type QueryFnType = typeof getTokenVersions;

type UseTokenVersionsOptions = {
  tokenID: string | number;
  config?: QueryConfig<QueryFnType>;
};

export const useTokenVersions = ({
  tokenID,
  config,
}: UseTokenVersionsOptions) =>
  useQuery({
    ...config,
    queryFn: async () => getTokenVersions({ tokenID }),
    queryKey: ['tokenVersions', tokenID],
  });
